<template>
  <div class="news_list" >
    <div class="list_wrap">
      <List v-model="loading" class="my-box" :finished="finished" @load="loadMore"> 
        <div class="item"  v-for="(item,index) in list" :key="index"  @click="LinkToNewsDetails({item:item,user:userInfo})">
          <div class="item_hot_1" v-if="item.covers.length==0">
            <p>{{item.title}}</p>
            <span>{{item.createAt}}</span>
          </div>
          <div class="item_hot_2" v-if="item.covers.length==1">
            <div class="item_hot_2_l">
                <p>{{item.title}}</p>
                <span>{{item.createAt}}</span>
            </div>
            <div class="item_hot_2_r">
                <img v-if="item.covers[0]" :src="item.covers[0]" v-load="'oNews'" >
                <img v-else src="@assets/img/new/icon-loading.png" >
            </div>
          </div>
          <div class="item_hot_3" v-if="item.covers.length>=2">
            <p>{{item.title}}</p>
            <div class="img2" :class="item.covers.length==2?'img_lengt_2':''">
              <div class="img-box"  v-for="(img,idx) in item.covers.slice(0,3)" :key="'c'+idx">
                <img v-if="img" :src="img" v-load="'oNews'" >
                <img v-else src="@assets/img/new/icon-loading.png" >
              </div>
            </div>
            <span>{{item.publishAt}}</span>
          </div>
        </div>
        <div slot="loading" class="f-tac loading">
          <img src="@assets/img/new/icon-loading.png" />
          loading...
        </div>
        <div slot="finished" class="f-tac loading">It's the end~</div>
      </List>
    </div>
  </div>
</template>

<script>
import gql from 'graphql-tag'
import moment from "moment";
import { List } from "vant";
import { mapGetters, mapActions } from "vuex";
export default {  
  name: "news-list",
  data() {
    return {
      loading: false,   //活动加载状态
      finished: false,  //活动是否完成状态
      list: [],         //活动列表
      pageIndex: 0,
      pageSize:20,
      queryArticleView:{},
    };
  },
  components: { List },
  computed: {
    ...mapGetters({
      userInfo: "getUserInfo",
      exhibitionId:"getExhibitionId"
    }),
  },
  created() {
  },
  methods: {
    ...mapActions({
      LinkToNewsDetails:'linkTo/LinkToNewsDetails'
    }),
    getList(){
      let query=gql`
      query queryArticleView($query:QueryInput!,$exhibitionId:Guid){
        queryArticleView(query:$query,exhibitionId:$exhibitionId){
          hasNextPage
          indexFrom
          pageIndex
          pageSize
          items{
            article{
             covers
             createAt
             title
             externalUrl
             publishAt
             id
            }
          }
        }
      }`
      let where={
        "Equal":{
          "n":"userId",
          "v":this.userInfo.userId
        },
      }
      let order=[
        {
          "N":"createAt",
          "v":0
        }
      ]
      let opt={
        page:this.pageIndex,
        size:this.pageSize,
        where:JSON.stringify(where),
        order:JSON.stringify(order)
      }
      this.$apollo.addSmartQuery("queryArticleView",{ 
        query:query,
        variables:{
         query:opt,
         exhibitionId:this.exhibitionId
        },
        fetchPolicy: 'network-only',    //清理缓存
        result(data){
          let res=JSON.parse(JSON.stringify(data.data.queryArticleView));
          // let res=data.data.queryProduct;
          let items=[]
          if(res&&res.items.length){
            res.items.forEach(el => {
              items.push(el.article);
            });
          }
          // console.log('资讯访问用户',items);
          if(items.length){
            items.forEach(e=>{
              if(e.covers&&e.covers.indexOf('[')!=-1){
                e.covers=JSON.parse(e.covers);
              }else{
                e.covers=[]
              }
              e.publishAt=moment(e.publishAt).format("YYYY/MM/DD");
            })
          }
          if(this.pageIndex==1){
            this.list=items
          }else{
            this.list=[...new Set([...this.list,...items])];
          }
          this.loading=false;
          if (!res.hasNextPage) {
            this.finished = true;
          }
        },
        error(err){
          this.loading=false;
          this.finished = true;
          console.log('err',err)
        }
      })
    },
    //
    loadMore(){
      if(this.finished) return;
      this.pageIndex+=1;
      this.getList();
    },
  }
};
</script>

<style scoped lang="scss">
.news_list{
  padding:0 0.3rem;
  .list_wrap{
    .my-box{
      .item{
        border-bottom: 1px solid #e6e6e6;
        p{
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            font-size: 0.28rem;
            line-height: 1.6;
            color: #222;
            margin:0.16rem 0 0.08rem;
        }
        span{
            font-size: 0.22rem;
            color: #999;
            line-height: 1.2;
            display: inline-block;
            padding:0.2rem 0;
        }
        .item_hot_2{
            display: flex;
            justify-content: space-between;
            padding:0.16rem 0 0.2rem;
            &_l{
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                width: calc(100% - 2.4rem);
                p{
                  font-size: 0.28rem;
                  line-height: 1.6;
                  color: #222;
                  overflow : hidden;
                  text-overflow: ellipsis;
                  display: -webkit-box;
                  -webkit-line-clamp: 2;
                  -webkit-box-orient: vertical;
                  white-space: normal;
                  margin:0;
                }
                span{
                    font-size: 0.22rem;
                    color: #999;
                    line-height: 1.2;
                    padding:0;
                }
            }
            &_r{
                width: 2.14rem;
                height: 1.28rem;
                img{
                  width: 100%;
                  height: 100%;
                  display: block;
                }
            }
        }
        .item_hot_3{
          .img2{
            display: flex;
            align-items: center;
            justify-content: space-between;
            &.img_lengt_2{
              &::after{
                content: '';
                width: 2.14rem;
                height: 1.28rem;
                display: block;
              }
            }
            .img-box{
              width: 2.14rem;
              height: 1.28rem;
              position: relative;
              img{
                position: absolute;
                left:0;
                top:0;
                bottom: 0;
                right: 0;
                width: 100%;
                height: 100%;
                display: block;
              }
            }
          }
        }
      }
    }
  }
  &::v-deep{
    .van-list__finished-text,
    .van-list__loading {
      width: 100%;
    }
  }
}
.f-tac {
  text-align: center;
  width: 100%;
  flex-shrink: 0;
  margin-top: 0.3rem;
}
.loading {
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    width: 18px;
    height: 18px;
    display: inline-block;
    margin-right: 5px;
    animation: 1s loader-01 linear infinite;
  }
}
@keyframes loader-01 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>
